module.exports = __webpack_public_path__ + "img/40_3.4936f309.png";